/**
 * 全局权限判断工具。
 *
 * 背景：/api/boss/profile 与 /api/ent/profile 返回 is_super_admin 与 node_keys
 * （角色勾选的权限节点 KEY 列表），登录后由路由守卫 setRoleData 写入
 * store.userData。页面按钮/入口需要按 rouKey 控制显隐或跳转时调用本方法。
 *
 * 调用方式：
 * - js / setup：import { hasPermission } from '@/utils/permission'，hasPermission('boss.setting')
 * - 模板：已挂载 globalProperties，v-if="$hasPermission('boss.setting')"
 *
 * 判断口径与 routePermission.js 路由过滤一致：
 * 超管恒 true；userData 为 null（未登录/接口失败）按最严格返回 false。
 */
import { useCounterStore } from 'src/stores/routerProcessing'

/**
 * 判断当前用户是否拥有指定权限节点。
 * @param {string} rouKey 权限节点 KEY（如 'boss.setting'）；不传/空串视为无权限控制，返回 true
 * @returns {boolean} 有权限返回 true，否则 false
 */
export const hasPermission = (rouKey) => {
  if (!rouKey) return true
  const store = useCounterStore()
  const user = store.userData
  if (user && user.is_super_admin === true) return true
  const keys = user && Array.isArray(user.node_keys) ? user.node_keys : []
  return keys.includes(rouKey)
}

export default { hasPermission }
